import { FaTimes } from 'react-icons/fa';

const BLOCK = 'LStudio__app_toast';

/*
    🔥 EL CUERPO DEL TOAST — UNO SOLO PARA LAS SEIS LIBRERÍAS

    Esta es la pieza que faltaba. Antes cada librería ponía SU estética,
    así que sonner se veía distinto de notistack y ninguno respetaba tus
    8 variantes ni tus tokens.

    Ahora las seis renderizan ESTE componente. Lo único que aporta cada
    librería es el motor: apilado, animación y auto-cierre.
*/

export const ToastBody = ({ type = 'info', title, text, onClose = null }) => (

    <div className={BLOCK} data-type={type} role="status">

        <span className={`${BLOCK}__bar`} aria-hidden="true" />

        <div className={`${BLOCK}__content`}>
            {title && <strong className={`${BLOCK}__title`}>{title}</strong>}
            {text && <p className={`${BLOCK}__text`}>{text}</p>}
        </div>

        {
            onClose && (
                <button type="button" className={`${BLOCK}__close LStudio__app_close_control`}
                    aria-label="Cerrar" onClick={onClose} >
                    <FaTimes />
                </button>
            )
        }

    </div>
);

/*
    🔥 VERSIÓN EN HTML

    sweetalert2 no acepta JSX. Mismas clases, mismo resultado visual.
*/
export const onToastBodyHtml = ({ type = 'info', title, text }) => `
    <div class="${BLOCK}" data-type="${type}">
        <span class="${BLOCK}__bar"></span>
        <div class="${BLOCK}__content">
            ${title ? `<strong class="${BLOCK}__title">${title}</strong>` : ''}
            ${text ? `<p class="${BLOCK}__text">${text}</p>` : ''}
        </div>
    </div>
`;
